import httpService from "../httpService";

export default {
  findByCaseMasterId(caseMasterId) {
    let params = {caseMasterId: caseMasterId};
    return httpService.get("/hcQuyCheQuyDinh/findByCaseMasterId", {
      params: params
    });
  },

  findAllByHcQuyCheQuyDinhCommonId(hcQuyCheQuyDinhCommonId) {
    let params = {hcQuyCheQuyDinhCommonId: hcQuyCheQuyDinhCommonId};
    return httpService.get("/hcQuyCheQuyDinh/findAllByHcQuyCheQuyDinhCommonId", {
      params: params
    });
  },

  findById(id) {
    return httpService.get(`/hcQuyCheQuyDinh/${id}`);
  },

  baoCaoChiDao(id, form) {
    return httpService.put(`/hcQuyCheQuyDinh/${id}/baoCaoChiDao`, form);
  },

  pheDuyet(id) {
    return httpService.put(`/hcQuyCheQuyDinh/${id}/pheDuyet`);
  },

  yeuCauBoSung(id, form) {
    return httpService.put(`/hcQuyCheQuyDinh/${id}/yeuCauBoSung`, form);
  },

  giaHan(id, form) {
    return httpService.put(`/hcQuyCheQuyDinh/${id}/giaHan`, form);
  },

  dangKyDeadline(id, form) {
    return httpService.put(`/hcQuyCheQuyDinh/${id}/dangKyDeadline`, form);
  },

  huyYeuCau(id, form) {
    return httpService.put(`/hcQuyCheQuyDinh/${id}/huyYeuCau`, form);
  },

  choYKien(id, form) {
    return httpService.put(`/hcQuyCheQuyDinh/${id}/choYKien`, form);
  },
};



// WEBPACK FOOTER //
// ./src/services/quychequydinh/hcQuyCheQuyDinhService.js